export const POWERBI_TOKEN = 'POWERBI_TOKEN';
export const GET_INITIAL_DATA = 'GET_INITIAL_DATA';
export const GET_STATS_ANALYTICS = 'GET_STATS_ANALYTICS';
export const GET_EMPLOYEES_STATS = 'GET_EMPLOYEES_STATS';
export const GET_PERFORMANCE_STATS = 'GET_PERFORMANCE_STATS';
export const UPDATE_ANSWERS_A = 'UPDATE_ANSWERS_A';
export const UPDATE_ANSWERS_B = 'UPDATE_ANSWERS_B';
